<topo-modal
  [isActive]="isActive"
  [backgroundCanClose]="true"
  (close)="onClose()">
  <div
    fxLayout="column"
    fxLayoutAlign="space-around center"
    style="padding: 30px">
    <div class="prompt-icon">
      <div style="position: relative; left: 20px; top: 20px">
        <i
          class="icon"
          [ngClass]="icon"
        style="font-size: 50px"></i>
      </div>
    </div>
    <div
      class="is-size-3"
      style="padding-top: 25px">
      <h5>{{ title }}</h5>
    </div>
    @if (!!!htmlMessage) {
      <div
        class="is-size-6"
        style="padding-top: 25px; width: 450px"
        [ngStyle]="{ 'text-align': messageAlign }">
        {{ message }}
      </div>
    }
    @if (!!htmlMessage) {
      <div
        class="is-size-6"
        style="padding-top: 25px; width: 450px"
        [ngStyle]="{ 'text-align': messageAlign }"
      [innerHTML]="htmlMessage"></div>
    }

    @if (listItems) {
      <div>
        <br />
        @for (item of listItems; track item) {
          <li>{{ item }}</li>
        }
      </div>
    }
    <div
      style="padding-top: 25px; padding-bottom: 25px"
      fxLayout="row">
      @if (!hideNo) {
        <div>
          <button
            class="button is-secondary is-medium cancel-button"
            style="width: 150px; margin-right: 10px"
            (click)="noClick()">
            {{ noText }}
          </button>
        </div>
      }
      <button
        [disabled]="disableYes || false"
        [ngClass]="{ 'disabled-cursor': disableYes }"
        class="button is-danger is-medium confirm-button"
        style="width: 150px"
        (click)="yesClick()">
        {{ yesText }}
      </button>
    </div>
  </div>
</topo-modal>
